import rest from "../rest";
import http from "../axios";
import { USER_PROCESS_OWNER_ENDPOINT } from "../constants";

export default {
  ...rest(USER_PROCESS_OWNER_ENDPOINT), //to get other endpoints
};
